import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CreateAppoinmentDTO, GetAppoinmentDTO } from "../../dtos/appoinments";
import {
  AddAttachmentDTO,
  AddExpensesDTO,
  AddNotesDTO,
  AddPLabtestDTO,
  AddProcedureDTO,
  ChangeAppointmentStatusDTO,
  ChangePaymentStatusDTO,
  ConfirmAppointmentBookingDTO,
  DeleteAppointmentDTO,
  DeleteAttachmentDTO,
  DeleteLabTestDTO,
  DeleteProcedureDTO,
  DeleteReferralDTO,
  EditLabTesteDTO,
  EditProcedureDTO,
  GetAllClinicPatientsDTO,
  GetAppointmentHistoryDTO,
  PaymentAddDTO,
  SendBulkEmailDTO,
  SendEmailDTO,
  SendOtp,
  SendSmsDTO,
  SendSpecificMesDTO,
} from "../../dtos/prescription";
import appointmentService from "./appointmentService";

const initialState = {
  Payload: null,
  createAppoinmentPayload: null,
  cancelAppointmentRequest: [],
  appointments: [],
  doctorRefferals: [],
  addAttachmentPayload: null,
  getAttachmentsPayload: null,
  appointment: null,
  deleteAttachmentPayload: null,
  appointmentHistoryPayload: null,
  addNotesPayload: null,
  getNotesPayload: null,
  changeAppointmentStatusPayload: null,
  appointmentDate: "",
  getInvoicePayload: null,
  addExpensesPayload: null,

  isError: false,
  isCreateAppointmentError: false,
  isAddAttachmentError: false,
  isGetAttachmentsError: false,
  isDeleteAttachmentError: false,
  isAppointmentHistoryError: false,
  isAddNotesError: false,
  isGetNotesError: false,
  isChangeAppointmentStatusError: false,
  isGetInvoiceError: false,
  isAddExpensesError: false,
  isCancelAppointmentError: false,
  isDoctorRefferalsError: false,

  isSuccess: false,
  isLoading: false,
  isNALoading: false,
  isCeateAppointmentLoading: false,
  isAddAttachmentLoading: false,
  isGetAttachmentsLoading: false,
  isDeleteAttachmentLoading: false,
  isAppointmentHistoryLoading: false,
  isDoctorRefferalsLoading: false,
  isAddNotesLoading: false,
  isGetNotesLoading: false,
  isChangeAppointmentStatusLoading: false,
  isGetInvoiceLoading: false,
  isAddExpensesLoading: false,
  isCancelAppointmentLoading: false,
  isCancelAppointmentSuccess: false,
  isDoctorRefferalsSuccess: false,

  message: "",
  createAppointmentMessage: "",
  addAttachmentMessage: "",
  getAttachmentsMessage: "",
  deleteAttachmentMessage: "",
  appointmentHistoryMessage: "",
  addNotesMessage: "",
  getNotesMessage: "",
  changeAppointmentStatusMessage: "",
  getInvoiceMessage: "",
  addExpensesMessage: "",
  cancelAppointmentMessage: "",
  isDoctorRefferalsMessage: "",
};

export const getCancelAppointmentRequests = createAsyncThunk(
  "/admin/cancel-appointment-requests/get",
  async (_, thunkAPI) => {
    try {
      return await appointmentService.getCancelAppointmentRequest();
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const deleteAppointment = createAsyncThunk(
  "/admin/appointment/delete",
  async (dto: DeleteAppointmentDTO, thunkAPI) => {
    try {
      return await appointmentService.deleteAppointment(dto);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
//////////////////////////////////Delete Doctor referal//////////////////////////////////
export const deleteReferalAppointment = createAsyncThunk(
  "/referral/delete",
  async (dto: DeleteReferralDTO, thunkAPI) => {
    try {
      return await appointmentService.deleteReferalAppointment(dto);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getAppointments = createAsyncThunk(
  "/appointments/get/all",
  async (dto: GetAppoinmentDTO, thunkAPI) => {
    try {
      return await appointmentService.getAllAppointments(dto);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getNewlyBookedAppointments = createAsyncThunk(
  "admin/appointments/get/bookings/all",
  async (dto: GetAppoinmentDTO, thunkAPI) => {
    try {
      return await appointmentService.getNewlyBookedAppointments(dto);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const createAppointment = createAsyncThunk(
  "appoinment/create",
  async (dto: CreateAppoinmentDTO, thunkAPI) => {
    try {
      return await appointmentService.createAppointment(dto);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const changeAppointmentStatus = createAsyncThunk(
  "appointment/delete",
  async (dto: ChangeAppointmentStatusDTO, thunkAPI) => {
    try {
      return await appointmentService.changeAppointmentStatus(dto);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const addPayment = createAsyncThunk(
  "/api/appointment/payment/add",
  async (dto: PaymentAddDTO, thunkAPI) => {
    try {
      return await appointmentService.addPayment(dto);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const changePaymentStatus = createAsyncThunk(
  "/api/admin/appointment/payment/status/change",
  async (dto: ChangePaymentStatusDTO, thunkAPI) => {
    try {
      return await appointmentService.changePaymentStatus(dto);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const addLabTest = createAsyncThunk(
  "/api/lab-tests-doc/add",
  async (dto: AddPLabtestDTO, thunkAPI) => {
    try {
      return await appointmentService.addLabTest(dto);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const editLabTest = createAsyncThunk(
  "/api/lab-tests-doc/edit",
  async (dto: EditLabTesteDTO, thunkAPI) => {
    try {
      return await appointmentService.editLabTest(dto);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const editProcedure = createAsyncThunk(
  "/api/procedures/edit",
  async (dto: EditProcedureDTO, thunkAPI) => {
    try {
      return await appointmentService.editProcedure(dto);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const addProcedure = createAsyncThunk(
  "/api/procedures/add",
  async (dto: AddProcedureDTO, thunkAPI) => {
    try {
      return await appointmentService.addProcedure(dto);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const ConfirmAppointmentBooking = createAsyncThunk(
  "/api/admin/appointment/offline-doc/confirm-booking",
  async (dto: ConfirmAppointmentBookingDTO, thunkAPI) => {
    try {
      return await appointmentService.confirmAppointmentBooking(dto);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const addAttachment = createAsyncThunk(
  "appointment/attachment/add",
  async (dto: AddAttachmentDTO, thunkAPI) => {
    try {
      return await appointmentService.addAttachment(dto);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getAttachments = createAsyncThunk(
  "appointment/attachment/get/{appointment_id}",
  async (appointmentId: string, thunkAPI) => {
    try {
      return await appointmentService.getAttachments(appointmentId);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const deleteAttachment = createAsyncThunk(
  "appointment/attachment/delete",
  async (dto: DeleteAttachmentDTO, thunkAPI) => {
    try {
      return await appointmentService.deleteAttachments(dto);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const appoinmentHistory = createAsyncThunk(
  "appointment/history",
  async (dto: GetAppointmentHistoryDTO, thunkAPI) => {
    try {
      return await appointmentService.appoinmentHistory(dto);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const addNotes = createAsyncThunk(
  "appointment/notes/add",
  async (dto: AddNotesDTO, thunkAPI) => {
    try {
      return await appointmentService.addNotes(dto);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getNotes = createAsyncThunk(
  "appointment/notes/view",
  async (appointmentId: string, thunkAPI) => {
    try {
      return await appointmentService.getNotes(appointmentId);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getInvoice = createAsyncThunk(
  "appointment/invoice/get",
  async (appointmentId: string, thunkAPI) => {
    try {
      return await appointmentService.getInvoice(appointmentId);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const addExpenses = createAsyncThunk(
  "appointment/expenses/update",
  async (dto: AddExpensesDTO, thunkAPI) => {
    try {
      return await appointmentService.addExpenses(dto);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const sendMessages = createAsyncThunk(
  "api/admin/send/bulk-sms",
  async (dto: SendSmsDTO, thunkAPI) => {
    try {
      return await appointmentService.sendSms(dto);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const sendEmail = createAsyncThunk(
  "api/admin/send/email",
  async (dto: SendBulkEmailDTO, thunkAPI) => {
    try {
      return await appointmentService.sendEmail(dto);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const sendBulkEmail = createAsyncThunk(
  "api/admin/send/bulk-email",
  async (dto: SendEmailDTO, thunkAPI) => {
    try {
      return await appointmentService.sendBulkEmail(dto);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const sendOtp = createAsyncThunk(
  "/api/auth/otp/get",
  async (dto: SendOtp, thunkAPI) => {
    try {
      return await appointmentService.sendOtp(dto);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const sendSpecificMessages = createAsyncThunk(
  "/api/admin/notify/user",
  async (dto: SendSpecificMesDTO, thunkAPI) => {
    try {
      return await appointmentService.sendSpecificSms(dto);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const deleteProcedure = createAsyncThunk(
  "/api/procedures/delete",
  async (dto: DeleteProcedureDTO, thunkAPI) => {
    try {
      return await appointmentService.deleteProcedure(dto);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const deleteLabTest = createAsyncThunk(
  "/api/lab-tests-doc/delete",
  async (dto: DeleteLabTestDTO, thunkAPI) => {
    try {
      return await appointmentService.deleteLabTest(dto);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getAllMedicalProcedures = createAsyncThunk(
  "/api/procedures/view",
  async (dto: GetAllClinicPatientsDTO, thunkAPI) => {
    try {
      return await appointmentService.getAllMedicalProcedures(dto);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getAllLabTest = createAsyncThunk(
  "/api/lab-tests-doc/view",
  async (doctor_id: number, thunkAPI) => {
    try {
      return await appointmentService.getAllLabTest(doctor_id);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const appointmentsSlice = createSlice({
  name: "appointments",
  initialState,
  reducers: {
    reset: () => initialState,
    appointmentClick: (state, action) => {
      state.appointment = action.payload;
    },
    changeAppointmentDate: (state, action) => {
      state.appointmentDate = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAppointments.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAppointments.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.appointments = action.payload;
      })
      .addCase(
        getAppointments.rejected,
        (state, action: PayloadAction<any>) => {
          state.isLoading = false;
          state.isError = true;
          state.message = action.payload;
        }
      )
      .addCase(createAppointment.pending, (state) => {
        state.isCeateAppointmentLoading = true;
      })
      .addCase(createAppointment.fulfilled, (state, action) => {
        state.isCeateAppointmentLoading = false;
        state.isSuccess = true;
        state.createAppoinmentPayload = action.payload;
        state.isCreateAppointmentError = false;
        state.createAppointmentMessage = "";
      })
      .addCase(
        createAppointment.rejected,
        (state, action: PayloadAction<any>) => {
          state.isCeateAppointmentLoading = false;
          state.isCreateAppointmentError = true;
          state.createAppointmentMessage = action.payload;
        }
      )
      .addCase(getAllLabTest.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllLabTest.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.Payload = action.payload;
        state.message = "";
      })
      .addCase(getAllLabTest.rejected, (state, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(getAllMedicalProcedures.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllMedicalProcedures.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.Payload = action.payload;
        state.message = "";
      })
      .addCase(
        getAllMedicalProcedures.rejected,
        (state, action: PayloadAction<any>) => {
          state.isLoading = false;
          state.isError = true;
          state.message = action.payload;
        }
      )
      .addCase(addAttachment.pending, (state) => {
        state.isAddAttachmentLoading = true;
      })
      .addCase(addAttachment.fulfilled, (state, action) => {
        state.isAddAttachmentLoading = false;
        state.isSuccess = true;
        state.addAttachmentPayload = action.payload;
        state.addAttachmentMessage = "";
      })
      .addCase(addAttachment.rejected, (state, action: PayloadAction<any>) => {
        state.isAddAttachmentLoading = false;
        state.isAddAttachmentError = true;
        state.addAttachmentMessage = action.payload;
      })
      .addCase(addLabTest.pending, (state) => {
        state.isAddExpensesLoading = true;
      })
      .addCase(addLabTest.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.Payload = action.payload;
        state.isError = false;
        state.message = "";
      })
      .addCase(addLabTest.rejected, (state, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(deleteLabTest.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteLabTest.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.Payload = action.payload;
        state.isError = false;
        state.message = "";
      })
      .addCase(deleteLabTest.rejected, (state, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(getAttachments.pending, (state) => {
        state.isGetAttachmentsLoading = true;
      })
      .addCase(getAttachments.fulfilled, (state, action) => {
        state.isGetAttachmentsLoading = false;
        state.isSuccess = true;
        state.getAttachmentsPayload = action.payload;
        state.getAttachmentsMessage = "";
      })
      .addCase(getAttachments.rejected, (state, action: PayloadAction<any>) => {
        state.isGetAttachmentsLoading = false;
        state.isGetAttachmentsError = true;
        state.getAttachmentsMessage = action.payload;
      })
      .addCase(addProcedure.pending, (state) => {
        state.isAddExpensesLoading = true;
      })
      .addCase(addProcedure.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.Payload = action.payload;
        state.isError = false;
        state.message = "";
      })
      .addCase(addProcedure.rejected, (state, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(editProcedure.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(editProcedure.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.message = "";
        state.Payload = action.payload;
      })
      .addCase(editProcedure.rejected, (state, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(deleteProcedure.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteProcedure.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.Payload = action.payload;
        state.isError = false;
        state.message = "";
      })
      .addCase(
        deleteProcedure.rejected,
        (state, action: PayloadAction<any>) => {
          state.isLoading = false;
          state.isError = true;
          state.message = action.payload;
        }
      )
      .addCase(changeAppointmentStatus.pending, (state) => {
        state.isChangeAppointmentStatusLoading = true;
      })
      .addCase(changeAppointmentStatus.fulfilled, (state, action) => {
        state.isChangeAppointmentStatusLoading = false;
        state.isSuccess = true;
        state.changeAppointmentStatusPayload = action.payload;
        state.isChangeAppointmentStatusError = false;
        state.changeAppointmentStatusMessage = "";
      })
      .addCase(
        changeAppointmentStatus.rejected,
        (state, action: PayloadAction<any>) => {
          state.isChangeAppointmentStatusLoading = false;
          state.isChangeAppointmentStatusError = true;
          state.changeAppointmentStatusMessage = action.payload;
        }
      )
      .addCase(changePaymentStatus.pending, (state) => {
        state.isChangeAppointmentStatusLoading = true;
      })
      .addCase(changePaymentStatus.fulfilled, (state, action) => {
        state.isChangeAppointmentStatusLoading = false;
        state.isSuccess = true;
        state.changeAppointmentStatusPayload = action.payload;
        state.isChangeAppointmentStatusError = false;
        state.changeAppointmentStatusMessage = "";
      })
      .addCase(
        changePaymentStatus.rejected,
        (state, action: PayloadAction<any>) => {
          state.isChangeAppointmentStatusLoading = false;
          state.isChangeAppointmentStatusError = true;
          state.changeAppointmentStatusMessage = action.payload;
        }
      )
      .addCase(deleteAttachment.pending, (state) => {
        state.isDeleteAttachmentLoading = true;
      })
      .addCase(deleteAttachment.fulfilled, (state, action) => {
        state.isDeleteAttachmentLoading = false;
        state.isSuccess = true;
        state.deleteAttachmentPayload = action.payload;
        state.isDeleteAttachmentError = false;
        state.deleteAttachmentMessage = "";
      })
      .addCase(
        deleteAttachment.rejected,
        (state, action: PayloadAction<any>) => {
          state.isDeleteAttachmentLoading = false;
          state.isDeleteAttachmentError = true;
          state.deleteAttachmentMessage = action.payload;
        }
      )
      .addCase(appoinmentHistory.pending, (state) => {
        state.isAppointmentHistoryLoading = true;
      })
      .addCase(appoinmentHistory.fulfilled, (state, action) => {
        state.isAppointmentHistoryLoading = false;
        state.isSuccess = true;
        state.appointmentHistoryPayload = action.payload;
        state.isAppointmentHistoryError = false;
        state.appointmentHistoryMessage = "";
      })
      .addCase(
        appoinmentHistory.rejected,
        (state, action: PayloadAction<any>) => {
          state.isAppointmentHistoryLoading = false;
          state.isAppointmentHistoryError = true;
          state.appointmentHistoryMessage = action.payload;
        }
      )
      .addCase(addNotes.pending, (state) => {
        state.isAddNotesLoading = true;
      })
      .addCase(addNotes.fulfilled, (state, action) => {
        state.isAddNotesLoading = false;
        state.isSuccess = true;
        state.addNotesPayload = action.payload;
        state.isAddNotesError = false;
        state.addNotesMessage = "";
      })
      .addCase(addNotes.rejected, (state, action: PayloadAction<any>) => {
        state.isAddNotesLoading = false;
        state.isAddNotesError = true;
        state.addNotesMessage = action.payload;
      })
      .addCase(getNotes.pending, (state) => {
        state.isGetNotesLoading = true;
      })
      .addCase(getNotes.fulfilled, (state, action) => {
        state.isGetNotesLoading = false;
        state.isSuccess = true;
        state.getNotesPayload = action.payload;
        state.isGetNotesError = false;
        state.getNotesMessage = "";
      })
      .addCase(getNotes.rejected, (state, action: PayloadAction<any>) => {
        state.isGetNotesLoading = false;
        state.isGetNotesError = true;
        state.getNotesMessage = action.payload;
      })
      .addCase(getInvoice.pending, (state) => {
        state.isGetInvoiceLoading = true;
      })
      .addCase(getInvoice.fulfilled, (state, action) => {
        state.isGetInvoiceLoading = false;
        state.isSuccess = true;
        state.getInvoicePayload = action.payload;
        state.isGetInvoiceError = false;
        state.getInvoiceMessage = "";
      })
      .addCase(getInvoice.rejected, (state, action: PayloadAction<any>) => {
        state.isGetInvoiceLoading = false;
        state.isGetInvoiceError = true;
        state.getInvoiceMessage = action.payload;
      })
      .addCase(addExpenses.pending, (state) => {
        state.isAddExpensesLoading = true;
      })
      .addCase(addExpenses.fulfilled, (state, action) => {
        state.isAddExpensesLoading = false;
        state.isSuccess = true;
        state.addExpensesPayload = action.payload;
        state.isAddExpensesError = false;
        state.addExpensesMessage = "";
      })
      .addCase(addExpenses.rejected, (state, action: PayloadAction<any>) => {
        state.isAddExpensesLoading = false;
        state.isAddExpensesError = true;
        state.addExpensesMessage = action.payload;
      })
      .addCase(sendMessages.pending, (state) => {
        state.isAddExpensesLoading = true;
      })
      .addCase(sendMessages.fulfilled, (state, action) => {
        state.isAddExpensesLoading = false;
        state.isSuccess = true;
        state.addExpensesPayload = action.payload;
        state.isAddExpensesError = false;
        state.addExpensesMessage = "";
      })
      .addCase(sendMessages.rejected, (state, action: PayloadAction<any>) => {
        state.isAddExpensesLoading = false;
        state.isAddExpensesError = true;
        state.addExpensesMessage = action.payload;
      })
      .addCase(sendEmail.pending, (state) => {
        state.isAddExpensesLoading = true;
      })
      .addCase(sendEmail.fulfilled, (state, action) => {
        state.isAddExpensesLoading = false;
        state.isSuccess = true;
        state.addExpensesPayload = action.payload;
        state.isAddExpensesError = false;
        state.addExpensesMessage = "";
      })
      .addCase(sendEmail.rejected, (state, action: PayloadAction<any>) => {
        state.isAddExpensesLoading = false;
        state.isAddExpensesError = true;
        state.addExpensesMessage = action.payload;
      })
      .addCase(sendSpecificMessages.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(sendSpecificMessages.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.Payload = action.payload;
        state.isError = false;
        state.message = "";
      })
      .addCase(
        sendSpecificMessages.rejected,
        (state, action: PayloadAction<any>) => {
          state.isLoading = false;
          state.isError = true;
          state.message = action.payload;
        }
      )
      .addCase(getNewlyBookedAppointments.pending, (state) => {
        state.isNALoading = true;
      })
      .addCase(getNewlyBookedAppointments.fulfilled, (state, action) => {
        state.isNALoading = false;
        state.isSuccess = true;
        state.appointments = action.payload;
      })

      .addCase(
        getNewlyBookedAppointments.rejected,
        (state, action: PayloadAction<any>) => {
          state.isNALoading = false;
          state.isError = true;
          state.message = action.payload;
        }
      )
      .addCase(getCancelAppointmentRequests.pending, (state) => {
        state.isCancelAppointmentLoading = true;
      })
      .addCase(getCancelAppointmentRequests.fulfilled, (state, action) => {
        state.isCancelAppointmentLoading = false;
        state.isCancelAppointmentSuccess = true;
        state.cancelAppointmentRequest = action.payload;
      })
      .addCase(
        getCancelAppointmentRequests.rejected,
        (state, action: PayloadAction<any>) => {
          state.isCancelAppointmentLoading = false;
          state.isCancelAppointmentError = true;
          state.cancelAppointmentMessage = action.payload;
        }
      );
  },
});

export const { reset, appointmentClick, changeAppointmentDate } =
  appointmentsSlice.actions;
export default appointmentsSlice.reducer;
